import { PropsWithChildren, useRef } from 'react'

import { Tooltip } from '../Popups/Tooltip/Tooltip'

import styles from './Truncate.module.scss'

export const Truncate: React.FC<PropsWithChildren> = ({ children }) => {
  const ref = useRef<HTMLSpanElement>(null)

  const isTooltipDisabled = (ref.current?.scrollWidth ?? 0) <= (ref.current?.clientWidth ?? 0)

  return (
    <Tooltip.New content={children} disabled={isTooltipDisabled}>
      <span ref={ref} className={styles.string}>
        {children}
      </span>
    </Tooltip.New>
  )
}
